import styled from '@emotion/styled';

export default styled('div')`
  padding-left: 10px;
`;
